export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11508.23eb03ee.jpg";